import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { useResetRecoilState } from 'recoil';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../routes/types';
import { useBatchTicketActions } from '../../../store/batchTicket/actions';
import {
  basketAdvisorOrderIdState,
  customerCartState,
  customerCartStatusState,
  productsCartState,
  productsCartStatusState,
} from '../../../store/batchTicket/atom';

export const useBatchTicketSent = () => {
  const { params: routeParams } =
    useRoute<RouteProp<SignedInRootStackParamList, 'BatchTicketSent'>>();
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const { onChangeCustomerCartStatus, onChangeProductsCartStatus } = useBatchTicketActions();

  const resetBasketAdvisorOrderIdState = useResetRecoilState(basketAdvisorOrderIdState);
  const resetCustomerCartState = useResetRecoilState(customerCartState);
  const resetCustomerCartStatusState = useResetRecoilState(customerCartStatusState);
  const resetProductsCartState = useResetRecoilState(productsCartState);
  const resetProductsCartStatusState = useResetRecoilState(productsCartStatusState);

  const data = routeParams.basketAdvisorOrder;

  const handleGoBack = () => navigate('BatchTicketRequests');
  const handleFollowTicket = () => navigate('BatchTicketRequests');
  const handleNewTicket = () => {
    resetBasketAdvisorOrderIdState();
    resetCustomerCartState();
    resetCustomerCartStatusState();
    resetProductsCartState();
    resetProductsCartStatusState();
    onChangeCustomerCartStatus('start');
    onChangeProductsCartStatus('locked');
    navigate('BatchTicket');
  };

  return { data, handleGoBack, handleFollowTicket, handleNewTicket };
};
